const member_list = items => {
  const $container = $('.element_list,.listContents').addClass('is-member').empty()
  $(`<h3 class="p-about-blockTitle">
      <span>MEMBER</span><small>メンバー一覧</small>
    </h3>`).insertBefore( $container )
  items.forEach(item => {
    $(`<a href="${item.href}" class="p-about-member__person">
        <img src="${item.thumb.replace(/\/content1\/up_img\/(staff_[^_]+)_l\.(jpg|jpeg)/i,'/Image/staff/$1_s.jpg')}" alt="${item.title} ${item.desc}" width="300" class="p-about-member__person-img">
        <p class="p-about-member__person-name">
          <small>${item.desc.split('|')[1].replace(/^\s|\s$/m,'').replace(/\s+?/,'<br>')}</small>
          <span>${item.title}</span>
        </p>
      </a>`).appendTo( $container )
  })
}
const article_info = (items,id) => {
  items = items.filter(item => item.id == id)
  if(items.length != 0){
    const name = {
      title: items[0].desc.split('|')[1].replace(/^\s|\s$/m,'').replace(/\s+?/,'<br>'),
      name: items[0].title,
      name_en: items[0].desc.split('|')[0].replace(/^\s|\s$/m,'')
    }
    $('.element_detail,body').addClass('is-member')
    $('.p-about-nav[data-plugin="currentMenu"]').currentMenu({
      mode:0,
      url: location.pathname+'?mode=list&cat=2'
    })
    $('.imgbox,.detailImgbox').append(`
      <p class="p-about-member__person-name">
        <small class="title">${name.title}</small>
        <span class="name">${name.name}</span>
        <small class="name_en">${name.name_en}</small>
      </p>
    `)
    $(`<div class="p-about-member__btnwrap">
      <a href="/aboutus/?mode=list&cat=2" class="button button-border-grey button-large">メンバー一覧</a>
    </div>`).insertAfter('.is-member .entry')

  }
}

export default function ABOUT() {
  const content = { module:'content1',content:'aboutus'}
  window.load['ready'] = new $.Deferred

  $(()=>{
    if( /mode=list&cat=2/.test(location.search) ) $('.element_list,.listContents').empty()
    window.load['ready'].resolve()
  })
  $.when(
    $.getArticle(content),
    window.load['ready']
  ).done(items => {
    //記事整形
    items = items.filter(item => item.category == 2)

    if( /mode=list&cat=2/.test(location.search) ) member_list(items)

    if( /mode=detail/.test(location.search) ) article_info(items,location.search.replace(/.*article=(\d+).*?/,'$1')) 

  })
}